import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

export const StyledPaper = styled(Paper, {
  shouldForwardProp: prop => prop !== 'isLoading'
})(({ theme, isLoading }) => ({
  padding: theme.spacing(2, 1),
  display: 'grid',
  gridGap: theme.spacing(2),
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: 'auto',
  opacity: isLoading ? 0 : 1,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3, 2)
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateAreas: '"label" "beginDate" "endDate" "project"'
  }
}));

export const LabelField = styled('div')({
  gridColumn: '1 / -1'
});

export const BeginDateField = styled('div')(({ theme }) => ({
  gridColumn: 1,
  [theme.breakpoints.down('sm')]: {
    gridColumn: '1 / -1'
  }
}));

export const EndDateField = styled('div')(({ theme }) => ({
  gridColumn: 2,
  [theme.breakpoints.down('sm')]: {
    gridColumn: '1 / -1'
  }
}));

export const ProjectField = styled('div', {
  shouldForwardProp: prop => prop !== 'hasMobilePlaceholder'
})(({ theme, hasMobilePlaceholder }) => ({
  gridColumn: '1 / -1',
  margin: '0 !important',
  [theme.breakpoints.down('sm')]: {
    height: '58px',
    '& span[style*="position: absolute"]': {
      marginTop: '20px',
      textAlign: 'left',
      left: '11px',
      bottom: '5px'
    },
    ...(hasMobilePlaceholder && {
      '& p': {
        marginBottom: '11px'
      }
    })
  }
}));

export const ButtonCnt = styled('div', {
  shouldForwardProp: prop => prop !== 'isLoading'
})(({ theme, isLoading }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  opacity: isLoading ? 0 : 1,
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));

export const FormWrapper = styled('form', {
  shouldForwardProp: prop => prop !== 'isLoading'
})(({ isLoading }) => ({
  ...(isLoading && {
    position: 'relative',
    height: '100%'
  })
}));

export const PreloaderCtn = styled('div')({
  position: 'absolute',
  width: '100%',
  height: 'calc(100% - 76px)',
  zIndex: 3,
  '& svg': {
    top: '0 !important',
    left: '0 !important',
    right: 0,
    bottom: 0,
    margin: 'auto',
    transform: 'none !important'
  }
});

export const CustomFieldsCnt = styled('div', {
  shouldForwardProp: prop => prop !== 'hasError'
})(({ theme, hasError }) => ({
  display: 'grid',
  gridGap: 16,
  gridTemplateRows: 'auto',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridColumn: 1,
  gridColumnEnd: 'none',
  ...(hasError && {
    outline: `2px solid ${theme.palette.error.main}`,
    outlineOffset: 5
  })
}));

export const customFieldStyle = {
  gridColumn: 1,
  gridColumnEnd: 'none'
};
